import { BlockOverrides } from 'baseui/block';

export const BLOCK: BlockOverrides = {
  Block: {
    style: {
      width: '100%',
      display: 'grid',
      gridTemplateColumns: 'auto 1fr',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginTop: '-16px',
      marginBottom: '8px',
    },
  },
};

export const ACTIONS: BlockOverrides = {
  Block: {
    style: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
    },
  },
};

export const TITLE: BlockOverrides = {
  Block: {
    style: {
      marginTop: 0,
      marginBottom: 0,
    },
  },
};
